
namespace TabAurous.ProductDevelopment {

    @Serenity.Decorators.registerClass()
    export class PDInterfaceGrid extends _Ext.GridBase<PDInterfaceRow, any> {
        protected getColumnsKey() { return 'ProductDevelopment.PDInterface'; }
        //protected getDialogType() { return PDInterfaceDialog; }
        protected getIdProperty() { return PDInterfaceRow.idProperty; }
        protected getInsertPermission() { return PDInterfaceRow.insertPermission; }
        protected getLocalTextPrefix() { return PDInterfaceRow.localTextPrefix; }
        protected getService() { return PDInterfaceService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30,  });

            this.toolbar.findButton('add-button').hide();
            this.setTitle("");
            //setTimeout(function () { this.refresh(); }, 2500);
        }

        protected createSlickGrid(): Slick.Grid {
            var grid = super.createSlickGrid();
            grid.setSelectionModel(new Slick.RowSelectionModel());
            return grid;
        }


        protected getColumns() {

            var columns = super.getColumns();
            columns.push(
                {
                    field: 'Action',
                    name: '',
                    format: ctx => '<button class="inline-action btn-success change-status" style="width:100%;">Update</button>',
                    width: 90,
                    minWidth: 90,
                    maxWidth: 90
                });

            return columns;
        }
        

    }
}